import { render, staticRenderFns } from "./HowDoPetsAffectMySecuritySystem.vue?vue&type=template&id=bfc48ebc&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports